import videojs from 'video.js';

// Get the Component base class from Video.js
var ProgressControl = videojs.getComponent('ProgressControl');

// The videojs.extend function is used to assist with inheritance. In
// an ES6 environment, `class TitleBar extends Component` would work
// identically.
var LoopSource = videojs.extend(ProgressControl, {

  // The constructor of a component receives two arguments: the
  // player it will be associated with and an object of options.
  constructor: function(player, options) {

    // It is important to invoke the superclass before anything else, 
    // to get all the features of components out of the box!
    ProgressControl.call(this, player, options);

    this.addClass('vjs-button-loop-source');

    this._loopTimeOut = null;
    this._looping = false;
    this._time = null;

    this.player().ready(() => {
      // Adjust progress bar
      const seekBar = this.getChild('seekBar');
      //
      this.trackTimeDisplay = seekBar.getChild('mouseTimeDisplay');
      // Add loop indicators
      this.startIndicator = seekBar.addChild('MouseTimeDisplay');
      this.startIndicator.addClass('loop-source-start');
      this.endIndicator = seekBar.addChild('MouseTimeDisplay');
      this.endIndicator.addClass('loop-source-end');
    });
  },

  _findPosition: function(el) {
    let box;
  
    if (el.getBoundingClientRect && el.parentNode) {
      box = el.getBoundingClientRect();
    }
  
    if (!box) {
      return {
        left: 0,
        top: 0
      };
    }
  
    const docEl = document.documentElement;
    const body = document.body;
  
    const clientLeft = docEl.clientLeft || body.clientLeft || 0;
    const scrollLeft = window.pageXOffset || body.scrollLeft;
    const left = box.left + scrollLeft - clientLeft;
  
    const clientTop = docEl.clientTop || body.clientTop || 0;
    const scrollTop = window.pageYOffset || body.scrollTop;
    const top = box.top + scrollTop - clientTop;
  
    // Android sometimes returns slightly off decimal values, so need to round
    return {
      left: Math.round(left),
      top: Math.round(top)
    };
  },

  _getPointerPosition: function(el, event) {
    const position = {};
    const box = this._findPosition(el);
    const boxW = el.offsetWidth;
    const boxH = el.offsetHeight;
  
    const boxY = box.top;
    const boxX = box.left;
    let pageY = event.pageY;
    let pageX = event.pageX;
  
    if (event.changedTouches) {
      pageX = event.changedTouches[0].pageX;
      pageY = event.changedTouches[0].pageY;
    }
  
    position.y = Math.max(0, Math.min(1, ((boxY - pageY) + boxH) / boxH));
    position.x = Math.max(0, Math.min(1, (pageX - boxX) / boxW));
  
    return position;
  },

  _getBoundingClientRect: function(el) {
    if (el && el.getBoundingClientRect && el.parentNode) {
      const rect = el.getBoundingClientRect();
      const result = {};
  
      ['bottom', 'height', 'left', 'right', 'top', 'width'].forEach(k => {
        if (rect[k] !== undefined) {
          result[k] = rect[k];
        }
      });
  
      if (!result.height) {
        result.height = parseFloat(computedStyle(el, 'height'));
      }
  
      if (!result.width) {
        result.width = parseFloat(computedStyle(el, 'width'));
      }
  
      return result;
    }
  },

  _clamp: function(number, min, max) {
    number = Number(number);
  
    return Math.min(max, Math.max(min, isNaN(number) ? min : number));
  },

  handleMouseMove: function(event) {
    const seekBar = this.getChild('seekBar');
    // get SeekBar
    const seekBarEl = seekBar.el();
    // get positioning elements
    const seekBarRect = this._getBoundingClientRect(seekBarEl);
    let seekBarPoint = this._getPointerPosition(seekBarEl, event).x;
    this._time = seekBarPoint * this.player().duration();
    if (LoopSource.loopMode) {
      if (LoopSource.canMoveStart) {
        this.startIndicator._currentTime = this._time;
        this.startIndicator._seekBarRect = seekBarRect;
        this.startIndicator._seekBarPoint = seekBarPoint;
        this.startIndicator.update(seekBarRect, seekBarPoint);
      }else if (LoopSource.canMoveEnd && (this._time > this.startIndicator._currentTime)) {
        this.endIndicator._currentTime = this._time;
        this.endIndicator._seekBarRect = seekBarRect;
        this.endIndicator._seekBarPoint = seekBarPoint;
        this.endIndicator.update(seekBarRect, seekBarPoint);
      }
    }else{
      this.removeClass('loop-source-enabled');
      LoopSource.canMoveStart = true;
      LoopSource.canMoveEnd = false;
    }

    if (!seekBar) {
      return;
    }

    const playProgressBar = seekBar.getChild('playProgressBar');
    const mouseTimeDisplay = this.trackTimeDisplay;

    if (!playProgressBar && !mouseTimeDisplay) {
      return;
    }

    // The default skin has a gap on either side of the `SeekBar`. This means
    // that it's possible to trigger this behavior outside the boundaries of
    // the `SeekBar`. This ensures we stay within it at all times.
    seekBarPoint = this._clamp(0, 1, seekBarPoint);

    if (mouseTimeDisplay) {
      mouseTimeDisplay.update(seekBarRect, seekBarPoint);
    }

    if (playProgressBar) {
      playProgressBar.update(seekBarRect, seekBar.getProgress());
    }
  },

  handleMouseDown: function(event) {
    if (LoopSource.loopMode) {
      this.addClass('loop-source-enabled');
      if (LoopSource.canMoveStart === true) {
        // lock start indicator
        LoopSource.canMoveStart = false;
        LoopSource.canMoveEnd = true;
        return;
      } else if (LoopSource.canMoveEnd && (this._time > this.startIndicator._currentTime)) {
        LoopSource.canMoveEnd = false;
        this.trigger('startLoop');
      }
    } else {
      this.player().currentTime(this._time);
    }
  },

});

LoopSource.loopMode = false;
LoopSource.canMoveStart = true;
LoopSource.canMoveEnd = false;

// Register the component with Video.js, so it can be used in players.
videojs.registerComponent('LoopSource', LoopSource);

export default LoopSource;
